export const NAMESPACES = {
  UI: "ui",
  INPUTS: "inputs",
  ERRORS: "errors",
  FEATURES: "features",
} as const;

export type NamespaceKey = (typeof NAMESPACES)[keyof typeof NAMESPACES];

export const ALL_NAMESPACES: NamespaceKey[] = Object.values(NAMESPACES);
